angular.module('bbl.module.call-records', [
  'bbl.services',
  'bbl.module.call-records.routing',
  'bbl.module.call-records.controller'
]);

require('./call-records.style.less');
require('./call-records.routing');
require('./call-records.controller');


/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/call-records/call-records.module.js
 ** module id = 359
 ** module chunks = 0
 **/